import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './utils/googleSafety' // Prevent google undefined errors
import './utils/i18n'; // Initialize i18n

console.log(`[VAIU App] Using Platform API URL: ${import.meta.env.PLATFORM_API_URL || 'Not Set'}`);

// Smart cache detection and cleanup
(async () => {
  const expectedTarget = import.meta.env.PLATFORM_API_URL || 'https://api.vaiu.io';
  const isIntentionallyStaging = expectedTarget.includes('api-stage.vaiu.io');
  
  console.log('🎯 Target API:', expectedTarget);
  console.log('🎯 Intentionally using staging?', isIntentionallyStaging);
  
  // Only check for problematic cache if we're NOT intentionally using staging
  if (!isIntentionallyStaging) {
    // Check for problematic service workers
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      registrations.forEach(reg => {
        console.log('🔍 Service Worker found:', reg.scope);
        if (reg.scope.includes('api-stage.vaiu.io')) {
          console.warn('🧹 Removing staging service worker (config mismatch):', reg.scope);
          reg.unregister();
        }
      });
    }
    
    // Check for problematic localStorage
    Object.keys(localStorage).forEach(key => {
      const value = localStorage.getItem(key);
      if (value && value.includes('api-stage.vaiu.io')) {
        console.warn('🧹 Found staging URL in localStorage (config mismatch):', key);
        // Optionally remove: localStorage.removeItem(key);
      }
    });
    
    // Check caches
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      for (const name of cacheNames) {
        if (name.includes('staging') || name.includes('api-stage')) {
          console.warn('🧹 Found staging cache (config mismatch):', name);
          // Optionally remove: await caches.delete(name);
        }
      }
    }
  }
})();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
